import CpfCnpj from '@react-br-forms/cpf-cnpj-mask'
import { ChevronLeft, Loader } from 'lucide-react'
import React, { FormEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logoWhite from 'src/assets/product-config/logo-white.png'
import { useAuth } from '../../hooks/auth'

export const SignInForm: React.FC<{ back?: () => void }> = ({ back }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const navigation = useNavigate()
  const { signIn, account, user } = useAuth()

  const [isKeyboardVisible, setKeyboardVisible] = useState(false)
  const [document, setDocument] = useState('')
  const [password, setPassword] = useState('')
  const [errorTimeout, setErrorTimeout] = useState<NodeJS.Timeout | null>(null)

  const handlePasswordVisibility = () => {
    setIsPasswordVisible((state) => !state)
  }

  const [mask, setMask] = useState<'999.999.999-99' | '99.999.999/9999-99'>(
    '999.999.999-99'
  )

  useEffect(() => {
    if (account) {
      navigation('/')
    }

    if (user?.type === 'GRAPHIC') {
      window.location.reload()
    }
  }, [account, user])

  const handleSignIn = async (event: FormEvent) => {
    event.preventDefault()

    if (!document || !password) {
      return
    }

    try {
      setLoading(true)
      setError('')
      console.log('Antes de signIn')
      await signIn({
        document: document.replace(/[/,.,-\s]/g, ''),
        password,
      })
      console.log('Depois de signIn')

      setLoading(false)
      setError('')
      navigation('/')
    } catch (err: any) {
      console.log(err)

      const errorMessage =
        err?.response?.data?.message ||
        'Erro ao entrar no sistema, entre em contato com o suporte.'

      setLoading(false)
      setError(errorMessage)
      // setError("Usuário e/ou senha inválido.");
      const timeout = setTimeout(() => {
        setError('')
      }, 5000)

      setErrorTimeout(timeout)
    }
  }

  useEffect(() => {
    return () => {
      if (errorTimeout) {
        clearTimeout(errorTimeout)
      }
    }
  }, [errorTimeout])

  const handleGoBack = async () => {
    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  return (
    <div className="flex h-full w-[40%] items-center p-24 justify-center">
      <form
        onSubmit={handleSignIn}
        className="flex relative flex-col gap-4 w-full items-center bg-black bg-opacity-40 rounded-3xl p-20 backdrop-filter backdrop-blur-md border border-gray-600"
      >
        <ChevronLeft
          onClick={back}
          className="absolute top-6 left-6 cursor-pointer"
          size={30}
          color="white"
        />
        <img alt="" src={logoWhite} className="w-[200px]" />
        <span className="text-zinc-300">Conecte-se e comece a usar!</span>
        <div className="flex flex-col w-full mt-8">
          <span className="text-zinc-300 font-bold text-lg">
            Entre com o CPF
          </span>
          <CpfCnpj
            placeholder="Digite seu CPF/CNPJ"
            className="text-zinc-900 w-full px-4 h-12 bg-white rounded-md border border-zinc-200 mb-2"
            type="text"
            onChange={(input: any) => setDocument(input.target.value)}
            value={document}
            autoComplete="on"
          />
          <span className="text-zinc-300 font-bold text-lg">Senha</span>
          <input
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            placeholder="***********"
            className="text-zinc-900 w-full px-4 h-12 bg-white rounded-md border border-zinc-200"
          />
        </div>
        <button className="w-full flex items-center justify-center text-white font-bold rounded-md border-zinc-400 border h-14 mt-2">
          {loading ? (
            <Loader size={22} color="#aaa" className="animate-spin" />
          ) : (
            'Entrar'
          )}
        </button>
      </form>
    </div>
  )
}
